/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MansionInputs */

const en_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mansion`)
};

const es_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mansión`)
};

const fr_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manoir`)
};

const de_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villa/Herrenhaus`)
};

const ja_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大邸宅`)
};

const zh_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公馆/大宅`)
};

const ar_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قصر`)
};

const id_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rumah Besar`)
};

const it_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villa d'Epoca / Magione`)
};

const ru_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Особняк`)
};

const pt_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mansão`)
};

const ko_val_mansion = /** @type {(inputs: Val_MansionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대저택`)
};

/**
* | output |
* | --- |
* | "Mansion" |
*
* @param {Val_MansionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_mansion = /** @type {((inputs?: Val_MansionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MansionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_mansion(inputs)
	if (locale === "es") return es_val_mansion(inputs)
	if (locale === "fr") return fr_val_mansion(inputs)
	if (locale === "de") return de_val_mansion(inputs)
	if (locale === "ja") return ja_val_mansion(inputs)
	if (locale === "zh") return zh_val_mansion(inputs)
	if (locale === "ar") return ar_val_mansion(inputs)
	if (locale === "id") return id_val_mansion(inputs)
	if (locale === "it") return it_val_mansion(inputs)
	if (locale === "ru") return ru_val_mansion(inputs)
	if (locale === "pt") return pt_val_mansion(inputs)
	return ko_val_mansion(inputs)
});